<template>
  <div class="scrollable indexDIV">
    <v-header></v-header>
    <div class="content">
      <div class="content_child">
        <img class="img1" src="../../assets/zn1.png" alt />
        <div class="msg">
          <img src="../../assets/zn_no.1.jpg" alt />
          <img style="margin-top:46px;" src="../../assets/zn_no.2.jpg" alt />
          <img style="margin-top:46px;" src="../../assets/zn_no.3.jpg" alt />
          <p class="p1">* 本活动的最终解释权归本公司所有 *</p>
          <p class="btn" @click="submit">已阅读，开始预约体检</p>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
import header from "../common/header.vue";
import footer from "../common/footer.vue";
export default {
  name: "indexDIV",
  data() {
    return {};
  },
  components: {
    "v-header": header,
    "v-footer": footer
  },
  created() {},
  mounted() {},
  methods: {
    submit() {
      this.$router.push({
        path: "/writeSubscribe",
        query: {
          type: "staff",
          batch: this.$route.query.batch,
          cardId: this.$route.query.cardId,
          cardNo: this.$route.query.cardNo
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.indexDIV {
  display: flex;
  flex-direction: column;
}
.content {
  width: 100%;
  height: 100%;
  overflow: auto;
  flex: 1;
  background: linear-gradient(
    180deg,
    rgba(252, 255, 254, 1) 0%,
    rgba(230, 255, 245, 1) 100%
  );
  .content_child {
    width: 1180px;
    margin: 0 auto;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .img1 {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 10;
    }
    .msg {
      // position: absolute;
      // z-index: 1;
      width: 1000px;
      padding: 100px 100px 68px 100px;
      background: #fff;
      box-shadow: 0px 0px 30px 0px rgba(0, 153, 153, 0.15);
      margin-top: 500px;
      margin-bottom: 100px;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
      }
      .p1 {
        font-size: 18px;
        font-weight: 400;
        color: #999;
        line-height: 18px;
        margin-top: 18px;
      }
      .btn {
        font-size: 20px;
        font-weight: bold;
        color: #fff;
        line-height: 20px;
        width: 400px;
        height: 50px;
        background: #01867f;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        margin-top: 40px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/activity.vue